<template>
  <div class="card-flow">
    <div class="echart-progress">
      <el-progress type="dashboard" :percentage="usedFlow" :color="colors" :stroke-width="10"></el-progress>
    </div>
  </div>
</template>
<script>
import { smallCardPoolUse } from "@/api/api.js";//小流量数据
export default {
  props:{
    groupId:{
      type:String,
      require:true
    }
  },
  data() {
    return {
      totalPool:0,
      usedPool:0,
      remainingPool:0,
      usedFlow:0,
      totalCount:0,
      totalCard:0,
      colors: [
        {color: '#6f7ad3', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#f56c6c', percentage: 100}
      ]
    };
  },
  methods: {
    smallFlow(){
      let params = {groupId:this.groupId}
      smallCardPoolUse(params).then(res =>{
        this.totalPool = res.data.data.totalPoolFlow;
        this.usedPool = res.data.data.usedPoolFlow;
        this.totalCount = res.data.data.totalCount;
        this.totalCard = res.data.data.totalCard;
        this.remainingPool = (this.totalPool - this.usedPool).toFixed(2);
        if(this.totalPool == 0){
          this.usedFlow = 0;
        }else{
          this.usedFlow = Number(this.formatDecimal(this.usedPool / this.totalPool * 100,2));
        };
      })
    },
    // 截取小数点的方法
    formatDecimal(num, decimal) {
      num = num.toString()
      let index = num.indexOf('.')
      if (index !== -1) {
          num = num.substring(0, decimal + index + 1)
      } else {
          num = num.substring(0)
      }
      return parseFloat(num).toFixed(decimal)
    },
  },
  mounted() {
    this.smallFlow();
  },
  created() {}
};
</script>
<style scoped lang="less">
  .card-flow{
    padding: 15px 20px 26px 20px;
    .echart-progress{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  /deep/ .el-progress-circle{
    height: 160px !important;
    width: 160px !important;
  }
</style>


